import { useEffect } from "react";
import cx from "classnames";
import styles from "./style.module.scss";
import FooterDocumentInfo from "./FooterDocumentInfo";
import FooterTotals from "./FooterTotals";
import FooterBankAccounts from "./FooterBankAccounts ";
import { useAppSelector } from "@/store/hooks";
import { DocumentSummaryProps } from "@/store/slices/eDocumentSlides";
import FooterPageNumber from "./FooterPageNumber";

type PrintPageFooterProps = {
  totalPages: number,
  currentPage: number,
  summary?: DocumentSummaryProps;
  summaryText?: string;
  currencyCode: number,
  exchangeRate: number,
  comments?: string[],
  noStripHtml?: boolean
  hideBankAccount?: boolean
  hideATVDisclaimer?: boolean
}

const PrintPageFooter = (props: PrintPageFooterProps) => {
  const { totalPages, currentPage, currencyCode, summary, summaryText,
    exchangeRate, comments = [], noStripHtml = false, hideBankAccount = false, hideATVDisclaimer = false } = props;
  const suscriptionData = useAppSelector(state => state.suscription.suscription)

  useEffect(() => {
  }, []);

  const renderFooterDocumentInfo = () => {
    return (
      <FooterDocumentInfo
        noStripHtml
        comments={comments}
        exchange_rate={exchangeRate}
        suscriptionCurrency={{
          currency_id: currencyCode
        }} />
    )

  }

  return (
    <div className={cx({
      "document-footer": true,
      'show-bank-account': !hideBankAccount
    })}
    >
      <div className={cx({
        "total": true,
        [styles.totalWrapper]: true
      })} >
        {!hideBankAccount && (<FooterBankAccounts />)}
        {hideBankAccount && renderFooterDocumentInfo()}
        <FooterTotals
          currencyCode={currencyCode}
          currentPage={currentPage}
          totalPages={totalPages}
          summary={summary}
          summaryText={summaryText}
        />
      </div>
      {!hideBankAccount && renderFooterDocumentInfo()}
      {!hideATVDisclaimer && (
        <div className={styles.tributacion}>
          {suscriptionData?.einvoice_status ?
            "Autorizada mediante resolución Nº DGT-R-48-2016 del 7 de octubre de 2016" :
            "Autorizado mediante Oficio #1197 de la D.G.T publicada en la Gaceta # 171 del 5-9-97"}
        </div>
      )}
      <FooterPageNumber
        currentPage={currentPage}
        totalPages={totalPages}
      />
    </div>
  );
}

export default PrintPageFooter;
